const interfaceText = {
    status: {
        inactive: gettext('Inactive'),
        active: gettext('Active'),
    },
    currency: gettext('Currency'),
    placeholder: gettext('placeholder'),
    NEW: gettext('New'),
    DEFAULT_PLACEHOLDER: gettext('Enter some text...'),
    REPORT_FEEDBACK: gettext('Report feedback'),
};

export default interfaceText;
